














import { Vue, Component, Prop } from 'vue-property-decorator';
import ISubmissionAnswer from '@/types/ISubmissionAnswer';
import messageBus from '../../utils/MessageBus';

@Component
export default class HistoryList extends Vue {
  $refs!: {
    history: HTMLDivElement,
  };

  @Prop() id!: string;
  @Prop() historyList!: object[];

  onAnswerSubmitted(submitted: ISubmissionAnswer) {
    if (submitted.status === 'success') {
      const historyElem = this.$refs.history;
      if (historyElem && historyElem.firstElementChild) {
        historyElem.firstElementChild.classList.add('success');
        setTimeout(() => {
          if (historyElem.firstElementChild) {
            historyElem.firstElementChild.classList.remove('success');
          }
        }, 900);
      }
    }
  }

  // noinspection JSUnusedGlobalSymbols
  mounted() {
    // briefly highlight most recent success
    messageBus.$on('answerSubmitted', this.onAnswerSubmitted);
  }

  // noinspection JSUnusedGlobalSymbols
  beforeDestroy() {
    messageBus.$off('answerSubmitted', this.onAnswerSubmitted);
  }
}
